import { Component, OnInit, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { PopupService } from '../../services/popup.service';
import { BaseService } from '../../services/base.service';
import { FeatureService } from '../../services/feature.service';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';


@Component({
  selector: 'app-mastermap-warning',
  templateUrl: './mastermap-warning.component.html',
  styleUrls: ['./mastermap-warning.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class MastermapWarningComponent implements OnInit {
  isPropertySpace: boolean = false;
  isProperty: boolean =  false;
  propertySpace: any;
  isFirstWarningChecked: boolean = false;
  isSecondWarningChecked: boolean = false;
  property: any;
  retailerData: any;
  isRetailer: boolean =  false;
  showWarningPopup: boolean = false;

  constructor(public popupService: PopupService, public baseService: BaseService, public ref : ChangeDetectorRef,
              public featureService: FeatureService) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    let w = (<any>window);
    w.Events.subscribe('confirmDeleteInMasterMap',(data)=> {
      if(data) {
        this.showWarningPopup = true;
        this.isProperty = data.isProperty;
        this.isPropertySpace = data.isPropertySpace;
        this.propertySpace = data.spaceData;
        this.property = data.property;
        this.ref.detectChanges();
      }
    });

    w.Events.subscribe('confirmDeleteRetailersInMasterMap',(data)=> {
      if(data) {
        this.showWarningPopup = true;
        this.isRetailer = true;
        this.retailerData = data; 
        this.ref.detectChanges();
      }
    });
  }

  toggleFirstWarnings() {
    this.isFirstWarningChecked = !this.isFirstWarningChecked;
    this.ref.detectChanges();

  } 

  toggleSecondWarnings() {
    this.isSecondWarningChecked = !this.isSecondWarningChecked;
    this.ref.detectChanges();
  }

  closePopup() {
    this.isFirstWarningChecked = false;
    this.isSecondWarningChecked = false;
    this.showWarningPopup = false;	
    this.ref.detectChanges();  
  }

  onSubmit() {
    let w = (<any>window);
    if(this.isRetailer) {
      w.Events.publish('removeRetailer', this.retailerData); 
    } else if(this.isPropertySpace) {
        w.Events.publish('deleteRowMastermap', this.propertySpace);      
    } else {
      w.contextualInfoWindow.closeAllInfoWindows();
      w.Events.publish('removeProperty', this.property);
    }
    this.closePopup();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/mastermap-warning/mastermap-warning.component.ts